import Component from "./component";
import { decodeHtml, generateClassName } from "./utils";
import { registerComponent } from "./jquery";
import { mmTextBox, mmTextBoxOptions } from "@/types";
import { prefix } from "./constants";
import { name } from "eslint-plugin-prettier/recommended";
import { mmSelectBox, mmSelectBoxOptions } from "dist/types/micromarin";
import mmButton from "./button";

class TextBox extends Component<mmTextBoxOptions> implements mmTextBox {
  private _dxTextBox!: DevExpress.ui.dxTextBox;

    private _mmButtons: mmButton[] = [];

  constructor(element: HTMLElement, options?: mmTextBoxOptions) {
    super(element, options);
 let rawValue = this._options.value;

    let valueForDX: string | number | boolean | undefined;
    if (typeof rawValue === "string") {
      valueForDX = decodeHtml(rawValue); 
    } else if (typeof rawValue === "number" || typeof rawValue === "boolean") {
      valueForDX = rawValue;
    } else {
      valueForDX = undefined;
    }
    this._dxTextBox = ($(this._element) as any)
      .dxTextBox({
        value: valueForDX,
        placeholder: this._options.placeholder,
        mode: this._options.mode,
        inputAttr: this._options.inputAttr,
        showClearButton: this._options.showClearButton,
        mask: this._options.mask,
        label: this._options.label,
        stylingMode: this._options.style,
        labelMode: this._options.labelMode,
        maskChar: this._options.maskChar,
        maxLength:this._options.maxLength,
        maskInvalidMessage: this._options.maskInvalidMessage,
        maskPlaceholder: this._options.maskPlaceholder,
        showMaskMode: this._options.showMaskMode,
        useMaskedValue: this._options.useMaskedValue,
        readOnly: this._options.readOnly,
        name: this._options.name,
        disabled: this._options.disabled,
        width: this._options.width,
        valueChangeEvent: this._options.valueChangeEvent ?? "change",
        onValueChanged: this._options.onValueChanged,
        onInput: this._options.onInput,
        onKeyUp: this._options.onKeyUp,
        onInitialized: this._options.onInitialized,
        elementAttr: {
          class: generateClassName(
            "text-box",
            this._options.color!,
            this._options.size!,
            this._options.shape,
            this._options.className,
          ),
          ...(this._options.attributes ?? {}),
        },
      })
      .dxTextBox("instance");
      if (this._options.buttons) {
      this._renderMMButtons(this._options.buttons);
    }
  }
 private _renderMMButtons(buttons: mmSelectBoxOptions["buttons"]) {
    const textEditorContainer = this._element.querySelector(".dx-texteditor-container") as HTMLElement;
    if (!textEditorContainer) return;

    let mmButtonsWrapper = textEditorContainer.querySelector(".mm-buttons-wrapper") as HTMLElement;
    if (!mmButtonsWrapper) {
      mmButtonsWrapper = document.createElement("div");
      mmButtonsWrapper.className = "mm-buttons-wrapper";
      mmButtonsWrapper.style.display = "flex";
      mmButtonsWrapper.style.gap = "4px";
      textEditorContainer.appendChild(mmButtonsWrapper);
    }

    buttons!.forEach((btn) => {
      if (typeof btn === "string") return;

      const container = document.createElement("div");
      container.classList.add("mm-button-container");
      mmButtonsWrapper.appendChild(container);

      const mmBtnOptions = {
        text: (btn.options as any)?.text || "",
        color: (btn.options as any)?.color || "primary",
        size: this._options.size,
        icon: (btn.options as any)?.icon,
        style: (btn.options as any)?.style || "contained",
        onClick: (e: any) => {
          (btn.options as any)?.onClick?.(e);
        },
      };

      const buttonInstance = new mmButton(container, mmBtnOptions);
      this._mmButtons.push(buttonInstance);
    });
  }
  public get value(): string | number | Date {
    const val = this._dxTextBox.option("value");
    return val !== undefined ? val : "";
  }
  public set value(val: string | number | Date) {
    this._dxTextBox.option("value", val !== undefined && val !== null ? String(val) : "");
  }

  
  public get mode(): "text" | "search" | "email" | "number" | "password" | "tel" | "url" {
  const val = this._dxTextBox.option("mode");
  return val !== undefined ? val : "text";
}

public set mode(val: "text" | "search" | "email" | "number" | "password" | "tel" | "url") {
  this._dxTextBox.option("mode", val as any);
}



  public get readOnly(): boolean {
    const val = this._dxTextBox.option("readOnly");
    return val !== undefined ? val : false;
  }
  public set readOnly(val: boolean) {
    this._dxTextBox.option("readOnly", val);
  }

  public get disabled(): boolean {
    const val = this._dxTextBox.option("disabled");
    return val !== undefined ? val : false;
  }
  public set disabled(val: boolean) {
    this._dxTextBox.option("disabled", val);
  }

  public get isEmpty(): boolean {
    const val = this.value;
    return val === undefined || val === null || val === "";
  }
  public set isEmpty(val: boolean) {
    if (val) {
      this.value = "";
    }
  }
  public get mask(): string | undefined {
    return this._dxTextBox.option("mask");
  }
  public set mask(val: string | undefined) {
    this._dxTextBox.option("mask", val);
  }
public get buttons(): mmButton[] {
  return this._mmButtons;
}

public set buttons(newButtons: mmTextBoxOptions["buttons"]) {
  const wrapper = this._element.querySelector(".mm-buttons-wrapper") as HTMLElement;

  if (wrapper) {
    wrapper.innerHTML = "";
    this._mmButtons = [];
  }

  if (!newButtons || !Array.isArray(newButtons)) return;

  this._renderMMButtons(newButtons);
}

  public getDefaults(): Partial<mmTextBoxOptions> {
    return {
      value: "",
      readOnly: false,
      disabled: false,
      color: "default",
      size: "md",
      mode:"text",
      width: "100%",

    };
  }
}

registerComponent("mmTextBox", TextBox);

export default TextBox;
